<template>
  <div>
    <HeadlineContainer headline="Project Categories" :breadcrumbs="[{text: 'Project Categories'}]">
      <router-link to="/project-categories/create" class="btn btn-white">
        <i class="fa fa-plus"></i> Create
      </router-link>
    </HeadlineContainer>

    <div class="container">
      <ProjectCategoryList/>
    </div>
  </div>
</template>

<script>
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import ProjectCategoryList from '../../../components/Administration/ProjectCategories/Panels/List'

export default {
  components: {HeadlineContainer, ProjectCategoryList}
}
</script>
